const sidebarProportionalWidth = 25
const contentProportionalWidth = 100 - sidebarProportionalWidth

export default {
  sidebarProportionalWidth,
  contentProportionalWidth
}



// WEBPACK FOOTER //
// ./src/styles/proportions.js